// extracted by mini-css-extract-plugin
export var blockedMessage = "_8r-3";
export var blockedOverlay = "_8r-1";
export var fadeIn = "_8r-2";
export var hereLink = "_8r-0";
export var slideUp = "_8r-4";